// @flow
import type { ERROR_TYPE } from './common';
import type { ROUTE_TYPE } from './routes';

export type MONITOR_TYPE = {
  id: number,
  first_name: string,
  last_name: string,
  routes?: Array<number>,
  dayRoutes?: Array<number>,
  phone: string,
  profile_picture: string
};

export type MONITOR_FETCH_STARTED_TYPE = {
  type: 'MONITOR_FETCH_STARTED',
  payload: number
};
export const MONITOR_FETCH_STARTED = 'MONITOR_FETCH_STARTED';

export type MONITOR_FETCH_SUCCEED_TYPE = {
  type: 'MONITOR_FETCH_SUCCEED',
  payload: MONITOR_TYPE
};
export const MONITOR_FETCH_SUCCEED = 'MONITOR_FETCH_SUCCEED';

export type MONITOR_FETCH_FAILED_TYPE = {
  type: 'MONITOR_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const MONITOR_FETCH_FAILED = 'MONITOR_FETCH_FAILED';

export type MONITORS_REGISTERED_TYPE = {
  type: 'MONITORS_REGISTERED',
  payload: {
    entities: {[number]: MONITOR_TYPE}
  }
};
export const MONITORS_REGISTERED = 'MONITORS_REGISTERED';

export type MONITOR_ROUTES_FETCH_STARTED_TYPE = {
  type: 'MONITOR_ROUTES_FETCH_STARTED',
  payload: number
};
export const MONITOR_ROUTES_FETCH_STARTED = 'MONITOR_ROUTES_FETCH_STARTED';

export type MONITOR_ROUTES_FETCH_SUCCEED_TYPE = {
  type: 'MONITOR_ROUTES_FETCH_SUCCEED',
  payload: {
    entities: {[number]: ROUTE_TYPE},
    order: Array<number>
  }
};
export const MONITOR_ROUTES_FETCH_SUCCEED = 'MONITOR_ROUTES_FETCH_SUCCEED';

export type MONITOR_ROUTES_FETCH_FAILED_TYPE = {
  type: 'MONITOR_ROUTES_FETCH_FAILED',
  payload: ERROR_TYPE
};

export const MONITOR_ROUTES_FETCH_FAILED = 'MONITOR_ROUTES_FETCH_FAILED';


export type ADD_MONITOR_ROUTES_TYPE = {
  type: 'ADD_MONITOR_ROUTES',
  payload: {
    id: number,
    routes: Array<number>
  }
};
export const ADD_MONITOR_ROUTES = 'ADD_MONITOR_ROUTES';

export type ADD_MONITOR_DAY_ROUTES_TYPE = {
    type: 'ADD_MONITOR_DAY_ROUTES',
    payload: {
        id: number,
        routes: Array<number>
    }
};
export const ADD_MONITOR_DAY_ROUTES = 'ADD_MONITOR_DAY_ROUTES';

export type ADD_MONITOR_ROUTE_STARTED_TYPE = {
  type: 'ADD_MONITOR_ROUTE_STARTED',
  payload: {
    id: number,
    idRoute: number,
  }
};
export const ADD_MONITOR_ROUTE_STARTED = 'ADD_MONITOR_ROUTE_STARTED';

export type ADD_MONITOR_ROUTE_SUCCESS_TYPE = {
  type: 'ADD_MONITOR_ROUTE_SUCCESS',
  payload: {
    id: number,
    routes: Array<number>,
  }
};
export const ADD_MONITOR_ROUTE_SUCCESS = 'ADD_MONITOR_ROUTE_SUCCESS';

export type ADD_MONITOR_ROUTE_FAILED_TYPE = {
  type: 'ADD_MONITOR_ROUTE_FAILED',
  payload: ERROR_TYPE,
};
export const ADD_MONITOR_ROUTE_FAILED = 'ADD_MONITOR_ROUTE_FAILED';

export type UPDATE_MONITOR_STARTED_TYPE = {
  type: 'UPDATE_MONITOR_STARTED',
  payload: Object
};
export const UPDATE_MONITOR_STARTED = 'UPDATE_MONITOR_STARTED';

export type UPDATE_MONITOR_SUCCEED_TYPE = {
  type: 'UPDATE_MONITOR_SUCCEED',
  payload: MONITOR_TYPE
};
export const UPDATE_MONITOR_SUCCEED = 'UPDATE_MONITOR_SUCCEED';

export type UPDATE_MONITOR_FAILED_TYPE = {
  type: 'UPDATE_MONITOR_FAILED',
  payload: ERROR_TYPE,
}
export const UPDATE_MONITOR_FAILED = 'UPDATE_MONITOR_FAILED';

export type MONITOR_ACTION_TYPE =
  | MONITOR_FETCH_STARTED_TYPE
  | MONITOR_ROUTES_FETCH_FAILED_TYPE
  | ADD_MONITOR_ROUTE_STARTED_TYPE
  | ADD_MONITOR_ROUTE_SUCCESS_TYPE
  | ADD_MONITOR_ROUTE_FAILED_TYPE
  | MONITOR_ROUTES_FETCH_SUCCEED_TYPE
  | ADD_MONITOR_ROUTES_TYPE
  | MONITOR_ROUTES_FETCH_STARTED_TYPE
  | MONITOR_FETCH_SUCCEED_TYPE
  | MONITOR_FETCH_FAILED_TYPE
  | MONITORS_REGISTERED_TYPE
  | UPDATE_MONITOR_STARTED_TYPE
  | UPDATE_MONITOR_SUCCEED_TYPE
  | UPDATE_MONITOR_FAILED_TYPE;



// WEBPACK FOOTER //
// ./src/scripts/types/monitors.js